import { JhiCapitalizePipe, JhiFilterPipe, JhiKeysPipe, JhiOrderByPipe, JhiPureFilterPipe, JhiTruncateCharactersPipe, JhiTruncateWordsPipe } from './pipe';
import { JhiMaxValidatorDirective, JhiMinValidatorDirective, JhiMaxbytesValidatorDirective, JhiMinbytesValidatorDirective, JhiSortDirective, JhiSortByDirective } from './directive';
import { JhiItemCountComponent, JhiBooleanComponent } from './component';
export var JHI_PIPES = [
    JhiCapitalizePipe,
    JhiFilterPipe,
    JhiKeysPipe,
    JhiOrderByPipe,
    JhiPureFilterPipe,
    JhiTruncateCharactersPipe,
    JhiTruncateWordsPipe
];
export var JHI_DIRECTIVES = [
    JhiMaxValidatorDirective,
    JhiMinValidatorDirective,
    JhiMaxbytesValidatorDirective,
    JhiMinbytesValidatorDirective,
    JhiSortDirective,
    JhiSortByDirective
];
export var JHI_COMPONENTS = [
    JhiItemCountComponent,
    JhiBooleanComponent
];



//////////////////
// WEBPACK FOOTER
// ./~/ng-jhipster/src/jhi-components.js
// module id = 1740
// module chunks = 1